import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import RadioButtonUncheckedRoundedIcon from '@mui/icons-material/RadioButtonUncheckedRounded';
export const ScaledTextButtonCheckboxIcon = ({ isChecked }) => {
    return isChecked ? (_jsx(CheckCircleRoundedIcon, { fontSize: 'inherit' })) : (_jsx(RadioButtonUncheckedRoundedIcon, { fontSize: 'inherit', style: { opacity: 0.4 } }));
};
